module.exports = __webpack_public_path__ + "img/tp.b705447e.jpeg";